import * as React from 'react'
import { ControlledMenu, MenuItem } from '@szhsin/react-menu'
import '@szhsin/react-menu/dist/index.css'
import { BusinessTripModel } from '@/app/models/businessTripModel'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

export type ActionKey =
  | 'changeCountry'
  | 'changeSettlementMonth'
  | 'changeSettlementDate'
  | 'changeExchangeRateDate'
  | 'setSettled'
  | 'setVehicle'
  | 'refreshRates'
  | 'refreshNumber'
  | 'refreshCosts'
  | 'refreshAccommodations'
  | 'copyToTeam'

const menuItemKeys: { key: string; action: ActionKey }[] = [
  { key: 'businessTrip.ctx-change-country', action: 'changeCountry' },
  { key: 'businessTrip.ctx-change-settlement-month', action: 'changeSettlementMonth' },
  { key: 'businessTrip.ctx-change-settlement-date', action: 'changeSettlementDate' },
  { key: 'businessTrip.ctx-change-exchange-rate-date', action: 'changeExchangeRateDate' },
  { key: 'businessTrip.ctx-set-settled', action: 'setSettled' },
  { key: 'businessTrip.ctx-set-vehicle', action: 'setVehicle' },
  { key: 'businessTrip.ctx-refresh-rates', action: 'refreshRates' },
  { key: 'businessTrip.ctx-refresh-number', action: 'refreshNumber' },
  { key: 'businessTrip.ctx-refresh-costs', action: 'refreshCosts' },
  { key: 'businessTrip.ctx-refresh-accommodations', action: 'refreshAccommodations' },
  { key: 'businessTrip.ctx-copy-to-team', action: 'copyToTeam' },
]

export interface BusinessTripMenuTarget {
  trip: BusinessTripModel
  anchorPoint: { x: number; y: number }
}

interface BusinessTripContextMenuProps {
  target: BusinessTripMenuTarget | null
  onClose: () => void
  onAction: (action: ActionKey, trip: BusinessTripModel) => void
}

const BusinessTripContextMenu: React.FC<BusinessTripContextMenuProps> = ({
  target,
  onClose,
  onAction,
}) => {
  const { t } = useLocalize()

  return (
    <ControlledMenu
      anchorPoint={target?.anchorPoint}
      state={target ? 'open' : 'closed'}
      onClose={onClose}
      onContextMenu={(e) => e.preventDefault()}
      className="tw-z-[10000]"
      portal
    >
      {menuItemKeys.map(({ key, action }) => (
        <MenuItem
          key={action}
          onClick={() => target && onAction(action, target.trip)}
        >
          {t(key)}
        </MenuItem>
      ))}
    </ControlledMenu>
  )
}

export default BusinessTripContextMenu
